import {
  getDecimalPoint,
  MEASUREMENT_KEYS,
  GlobalUnitEnum,
} from "../unit-conversion";

const mapperForUnitConversionTiltView = (
  inputItemObject,
  reportColumns,
  globalUnit = GlobalUnitEnum.IMPERIAL
) => {
  // Helper function to format decimal points only
  const formatDecimalPoints = (value, measurementKey) => {
    if (value === null || value === undefined || value === "") return value;
    const numValue = parseFloat(value);
    if (isNaN(numValue)) return value;
    const decimalPoints = getDecimalPoint(measurementKey, globalUnit);
    return numValue.toFixed(decimalPoints);
  };

  //current
  inputItemObject.current_low = formatDecimalPoints(
    inputItemObject.current_low,
    MEASUREMENT_KEYS.AMPS
  );
  inputItemObject.current_avg = formatDecimalPoints(
    inputItemObject.current_avg,
    MEASUREMENT_KEYS.AMPS
  );
  inputItemObject.current_high = formatDecimalPoints(
    inputItemObject.current_high,
    MEASUREMENT_KEYS.AMPS
  );

  //volt
  inputItemObject.volt_low = formatDecimalPoints(
    inputItemObject.volt_low,
    MEASUREMENT_KEYS.VOLTS
  );
  inputItemObject.volt_avg = formatDecimalPoints(
    inputItemObject.volt_avg,
    MEASUREMENT_KEYS.VOLTS
  );
  inputItemObject.volt_high = formatDecimalPoints(
    inputItemObject.volt_high,
    MEASUREMENT_KEYS.VOLTS
  );

  //travel speed
  inputItemObject.travel_speed_low = formatDecimalPoints(
    inputItemObject.travel_speed_low,
    MEASUREMENT_KEYS.TRAVEL_SPEED
  );
  inputItemObject.travel_speed_avg = formatDecimalPoints(
    inputItemObject.travel_speed_avg,
    MEASUREMENT_KEYS.TRAVEL_SPEED
  );
  inputItemObject.travel_speed_high = formatDecimalPoints(
    inputItemObject.travel_speed_high,
    MEASUREMENT_KEYS.TRAVEL_SPEED
  );

  //heat(calculated)
  inputItemObject.heat_low = formatDecimalPoints(
    inputItemObject.heat_low,
    MEASUREMENT_KEYS.HEAT
  );
  inputItemObject.heat_avg = formatDecimalPoints(
    inputItemObject.heat_avg,
    MEASUREMENT_KEYS.HEAT
  );
  inputItemObject.heat_high = formatDecimalPoints(
    inputItemObject.heat_high,
    MEASUREMENT_KEYS.HEAT
  );

  //true energy
  inputItemObject.true_energy_low = formatDecimalPoints(
    inputItemObject.true_energy_low,
    MEASUREMENT_KEYS.TRUE_ENERGY
  );
  inputItemObject.true_energy_avg = formatDecimalPoints(
    inputItemObject.true_energy_avg,
    MEASUREMENT_KEYS.TRUE_ENERGY
  );
  inputItemObject.true_energy_high = formatDecimalPoints(
    inputItemObject.true_energy_high,
    MEASUREMENT_KEYS.TRUE_ENERGY
  );

  //wire speed
  inputItemObject.wire_speed_low = formatDecimalPoints(
    inputItemObject.wire_speed_low,
    MEASUREMENT_KEYS.WIRE_SPEED
  );
  inputItemObject.wire_speed_avg = formatDecimalPoints(
    inputItemObject.wire_speed_avg,
    MEASUREMENT_KEYS.WIRE_SPEED
  );
  inputItemObject.wire_speed_high = formatDecimalPoints(
    inputItemObject.wire_speed_high,
    MEASUREMENT_KEYS.WIRE_SPEED
  );

  //oscillation width
  inputItemObject.oscillation_width_low = formatDecimalPoints(
    inputItemObject.oscillation_width_low,
    MEASUREMENT_KEYS.OSCILLATE_WIDTH
  );
  inputItemObject.oscillation_width_avg = formatDecimalPoints(
    inputItemObject.oscillation_width_avg,
    MEASUREMENT_KEYS.OSCILLATE_WIDTH
  );
  inputItemObject.oscillation_width_high = formatDecimalPoints(
    inputItemObject.oscillation_width_high,
    MEASUREMENT_KEYS.OSCILLATE_WIDTH
  );

  //frequency
  inputItemObject.frequency_low = formatDecimalPoints(
    inputItemObject.frequency_low,
    MEASUREMENT_KEYS.FREQUENCY
  );
  inputItemObject.frequency_avg = formatDecimalPoints(
    inputItemObject.frequency_avg,
    MEASUREMENT_KEYS.FREQUENCY
  );
  inputItemObject.frequency_high = formatDecimalPoints(
    inputItemObject.frequency_high,
    MEASUREMENT_KEYS.FREQUENCY
  );

  //target
  inputItemObject.target_low = formatDecimalPoints(
    inputItemObject.target_low,
    MEASUREMENT_KEYS.TARGET
  );
  inputItemObject.target_avg = formatDecimalPoints(
    inputItemObject.target_avg,
    MEASUREMENT_KEYS.TARGET
  );
  inputItemObject.target_high = formatDecimalPoints(
    inputItemObject.target_high,
    MEASUREMENT_KEYS.TARGET
  );

  //horizontal bias
  inputItemObject.horizontal_bias_low = formatDecimalPoints(
    inputItemObject.horizontal_bias_low,
    MEASUREMENT_KEYS.HORIZONTAL_BIAS
  );
  inputItemObject.horizontal_bias_avg = formatDecimalPoints(
    inputItemObject.horizontal_bias_avg,
    MEASUREMENT_KEYS.HORIZONTAL_BIAS
  );
  inputItemObject.horizontal_bias_high = formatDecimalPoints(
    inputItemObject.horizontal_bias_high,
    MEASUREMENT_KEYS.HORIZONTAL_BIAS
  );

  //total wire consumed
  inputItemObject.total_wire_consumed_low = formatDecimalPoints(
    inputItemObject.total_wire_consumed_low,
    MEASUREMENT_KEYS.TOTAL_WIRE_CONSUMED
  );
  inputItemObject.total_wire_consumed_avg = formatDecimalPoints(
    inputItemObject.total_wire_consumed_avg,
    MEASUREMENT_KEYS.TOTAL_WIRE_CONSUMED
  );
  inputItemObject.total_wire_consumed_high = formatDecimalPoints(
    inputItemObject.total_wire_consumed_high,
    MEASUREMENT_KEYS.TOTAL_WIRE_CONSUMED
  );

  //arc impedance
  inputItemObject.arcImpedance_low = formatDecimalPoints(
    inputItemObject.arcImpedance_low,
    MEASUREMENT_KEYS.ARC_IMPEDANCE
  );
  inputItemObject.arcImpedance_avg = formatDecimalPoints(
    inputItemObject.arcImpedance_avg,
    MEASUREMENT_KEYS.ARC_IMPEDANCE
  );
  inputItemObject.arcImpedance_high = formatDecimalPoints(
    inputItemObject.arcImpedance_high,
    MEASUREMENT_KEYS.ARC_IMPEDANCE
  );

  return inputItemObject;
};

export const tiltViewHelper = {
  mapperForUnitConversionTiltView,
};
